import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImageNameSearch } from '../../components/filters/ImageNameSearch';
import { IProjectDetailsImagesStore } from '../../projectDetailsImages.store';
import { IImageFilterService } from '../../services/imageFilters.service';

export const ImageNameSearchContainer = observer((): ReactElement => {
  const imageFilterService = useInjection(IImageFilterService.$);
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);

  const handleImageNameChangeAsync = async (imageName: string): Promise<void> => {
    await imageFilterService.setImageNameAsync(imageName);
  };

  const imageFilters = imagesStore.imageFilters;

  return (
    <ImageNameSearch
      searchText={imageFilters.imageName}
      onSearchChange={handleImageNameChangeAsync}
    />
  );
});
